export const removeServiceWorker = () => {
	if (navigator && 'serviceWorker' in navigator) {
		// @ts-ignore We don't care about the rest of the properties as we're not allowing to register
		navigator.serviceWorker.register = () => console.log('Service worker registration is not allowed')
		return Promise.resolve()
	}
}
